export default {
    methods: {
        handleThrowError(e) {
            this.$helpers.handleThrowError(e);
        },
    },
};
